import Store from 'ember-data/store';

import { service } from '@ember/service';

import { fetchWithCache } from 'rise-ui/utils/fastboot.js';

export default class StoreService extends Store {
  @service ssr;
  // @service requestManager;

  peekRecords(modelName, ids) {
    const records = [];
    [].concat(ids || []).forEach(id => {
      const record = this.peekRecord(modelName, id);
      if (record) {
        records.push(record);
      }
    });
    return records;
  }

  queryWithCache(cacheKey, modelName, query, options = {}) {
    return fetchWithCache(modelName, this.ssr,
      () => this.query(modelName, query, options),
      {
        id: cacheKey,
        serialize: r => r.serialize({ includeId: true }),
        deserialize: r => {
          r.data.forEach(result => this.pushPayload(modelName, result));
          return this.peekRecords(modelName, r.ids);
        },
      }
    );
  }
}
